<li class="nav-item">
  <a class="nav-link" [routerLink]="routeLink()" routerLinkActive="active">
    <i [class]="iconStyles()"></i><span class="ms-2">{{ title() }}</span>
  </a>
</li>
